<div class="row filtros-header" style="
          border-bottom: 1px solid #dee2e6;
          justify-content: start;
          align-items: center;
        " *ngIf="isVisible">
  <div class="col mt-1">
    <h4>
      Declaración circulante
    </h4>
  </div>
</div>

<form [formGroup]='formDeclaracion' novalidate *ngIf="isVisible">
  <div class="row">
    <div class="col">
      <h5>Billetes</h5>
    </div>
  </div>
  <div class="row ">
    
    <div class="col" style="max-width: 200px;">
      <div class="md-form">
        <input value="" type="text" id="billets20" class="form-control" placeholder="Cantidad" #billets20
          formControlName="valor20M" monto />
        <label for="billets20">20.000 CLP</label>
      </div>
    </div>
    <div class="col" style="max-width: 200px;">
      <div class="md-form">
        <input value="" type="text" id="billets10" class="form-control" placeholder="Cantidad" #billets10
          formControlName="valor10M" monto />
        <label for="billets10">10.000 CLP</label>
      </div>
    </div>
    <div class="col" style="max-width: 200px;">
      <div class="md-form">
        <input value="" type="text" id="billets5" class="form-control" placeholder="Cantidad" #billets5
          formControlName="valor05M" monto />
        <label for="billets5">5.000 CLP</label>
      </div>
    </div>
    <div class="col" style="max-width: 200px;">
      <div class="md-form">
        <input value="" type="text" id="billets2" class="form-control" placeholder="Cantidad" #billets2
          formControlName="valor02M" monto />
        <label for="billets2">2.000 CLP</label>
      </div>
    </div>
    <div class="col" style="max-width: 200px;">
      <div class="md-form">
        <input value="" type="text" id="billets1" class="form-control" placeholder="Cantidad" #billets1
          formControlName="valor01M" monto />
        <label for="billets1">1.000 CLP</label>
      </div>
    </div>
  </div>


  <div class="row">
    <div class="col">
      <h5>Monedas</h5>
    </div>
  </div>
  <div class="row">
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input value="" type="text" id="mone500" class="form-control" placeholder="Cantidad" #mone500
            formControlName="valor500" monto />
          <label for="mone500">500 CLP</label>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input value="" type="text" id="mone100" class="form-control" placeholder="Cantidad" #mone100
            formControlName="valor100" monto />
          <label for="mone100">100 CLP</label>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input value="" type="text" id="mone50" class="form-control" placeholder="Cantidad" #mone50
            formControlName="valor050" monto />
          <label for="mone50">50 CLP</label>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input value="" type="text" id="mone10" class="form-control" placeholder="Cantidad" #mone10
            formControlName="valor010" monto />
          <label for="mone10">10 CLP</label>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input value="" type="text" id="mone05" class="form-control" placeholder="Cantidad" #mone05
            formControlName="valor005" monto />
          <label for="mone10">5 CLP</label>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input value="" type="text" id="mone01" class="form-control" placeholder="Cantidad" #mone01
            formControlName="valor001" monto />
          <label for="mone10">1 CLP</label>
        </div>
      </div>
  </div>


  <div class="row">
    <div class="col">
      <div class="table-responsive mt-1">
        <table class="table table-striped table-hover table-sm align-middle">
          <thead class="blue lighten-5">
            <tr>
              <th style="text-align: right;">Monto depósito</th>
              <td align="right"><strong>$ {{total | numerico}}</strong></td>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</form>